module.exports = __webpack_public_path__ + "static/media/css-3.2db97d69.svg";